<template>
  <div id="tablePage">
    <!-- 资金状况 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="tradeDay"
          label="交易日期"
        >
        </el-table-column>
        <el-table-column
          prop="balanceQc"
          label="期初余额"
        >
        </el-table-column>
        <el-table-column
          prop="amountTransferIn"
          label="划入资金"
        >
        </el-table-column>
        <el-table-column
          prop="amountTransferOut"
          label="划出资金"
        >
        </el-table-column>
        <el-table-column
          prop="handselCurr"
          label="当日订金"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="handselYest"
          label="上日订金"
          min-width="100"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="effectiveValueCurr"
          label="当日有效货值"
          min-width="200"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="effectiveValueYest"
          label="上日有效货值"
          min-width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="tradeFee"
          label="当日交易手续费"
        >
        </el-table-column>
        <el-table-column
          prop="tradeProfit"
          label="当日转让盈亏"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="stampTax"
          label="当日印花税"
          width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="deliveryHandselCurr"
          label="当日交收担保金"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="deliveryHandselYest"
          label="上日交收担保金"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="deliveryFee"
          label="交收手续费"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="deliveryValueVary"
          label="当日交收货值变化"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="goodsFundsOut"
          label="当日货款支出"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="goodsFundsIn"
          label="当日货款收入"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="penalty"
          label="当日违约金"
          min-width="155"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="compensateFee"
          label="当日补偿款"
          width="155"
        >
        </el-table-column> -->
        <el-table-column
          prop="balanceQm"
          label="当前余额"
        >
        </el-table-column>
        <el-table-column
          prop="equityQm"
          label="期末权益"
        >
        </el-table-column>
        <el-table-column
          prop="amountAdditional"
          label="需追加资金"
        >
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['time', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        'bsFlag': '',
        'closePl': 0,
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'fee': 0,
        'firmId': 0,
        'holdDetailId': 0,
        'margin': 0,
        'ocFlag': '',
        'orderId': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tqTip': 0,
        'tradeDay': 0,
        'tradeId': 0,
        'tradeType': 0,
        'updateTime': 0,
        'stampFee': 0
      },
      isNetWrong: false
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocol.param_findUserReportOrderMargin.data.page = this.pageData.currentPage - 1
      protocol.param_findUserReportOrderMargin.data.size = '' + this.pageData.pageSize
      protocol.param_findUserReportOrderMargin.data.startDate = this.time[0]
      protocol.param_findUserReportOrderMargin.data.endDate = this.time[1]
      protocol.param_findUserReportOrderMargin.data.sort = [
        {
          direction: 'DESC',
          property: 'trade_day'
        }
      ]
      http.gPost(protocol.param_findUserReportOrderMargin).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            // this.TradeListSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinches.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    // 判断数据类型
    judgeDataType(arr) {
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserClinches.data.sort[0].direction = 'ASC'
      } else {
        protocol.queryUserClinches.data.sort[0].direction = 'DESC'
      }
      // protocol.queryUserClinches.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPost(protocol.queryUserClinches).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.TradeListSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinches.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
<style lang="scss" scoped>

</style>
<style>
#sixTabPage .el-table--border::after,#sixTabPage .el-table--group::after, .el-table::before{
 background-color:transparent;
}
#sixTabPage .el-table td,#sixTabPage .el-table th.is-leaf{
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
#sixTabPage .el-table--border,#sixTabPage .el-table--group{
 border:none;
}
#sixTabPage .el-table td div{
  text-align:center;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
#sixTabPage .el-table--border td, #sixTabPage .el-table--border th,#sixTabPage .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid rgba(0, 0, 0, 0.1);
}
#sixTabPage .el-pagination button:disabled,
#sixTabPage .el-pagination .btn-prev,
#sixTabPage .el-pagination .btn-next,
#sixTabPage .el-pager li,
#sixTabPage .el-pagination__editor.el-input .el-input__inner,
#sixTabPage .el-pagination .el-select .el-input .el-input__inner,
#sixTabPage .el-table table tr,
#sixTabPage .el-table th,
#sixTabPage .el-table,
#sixTabPage .el-table__footer-wrapper tbody td,
#sixTabPage .el-table__header-wrapper tbody td {
  background: #ffffff;
}
#sixTabPage .el-table td,#sixTabPage .el-table th{
    padding:2px 0;
}
#sixTabPage .el-table__footer-wrapper td{
    border-top:none;
}
#sixTabPage .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
#sixTabPage .el-table__body tr.current-row > td,
#sixTabPage .el-table__body tr.hover-row.current-row > td,
#sixTabPage .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#sixTabPage .el-table__body tr.hover-row.el-table__row--striped > td,
#sixTabPage .el-table__body tr.hover-row > td,
#sixTabPage  .el-table th.el-table__cell {
  background: #ffffff;
}
#sixTabPage .el-table__header-wrapper th > .cell{
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  text-align:center;
  line-height: 34px;
}
#sixTabPage .el-table .el-table__cell{
  padding:4px 0;
}
#sixTabPage .el-table td.el-table__cell,#sixTabPage .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

</style>
